import React from "react";

import { assetImg } from "@/modules/moduleImporter";
import { renderResultHistory } from "@/modules/commonPopupResultHistory";
import { IPopupResultHistoryProps } from "@/types/PopupResultHistoryTypes";

import "../index.scss";
import { getBasePcode } from "@/modules/gamePcode";
import { getDTCardValue } from "@/modules/cards";
import { isNullOrEmpty } from "@/modules/commonMobile";

//Dragon Tiger
export default class M23 extends React.PureComponent<IPopupResultHistoryProps> {
	render() {
		// Template const
		const {
			langdata,
			orientation,
			portraitTabIndex
		} = this.props;

		const basePcode = getBasePcode(this.props.activeGame.pcode);

		// Red card colours
		const reds = ["h", "d"];

		// PORTRAIT TAB NAMES
		const tabNames = ["Win Cards", "Dragon 50:50", "Tiger 50:50"];

		// HEADERS
		const landscapeHeaders = [
			`${langdata["txt_round_id"]}`,
			`${langdata["txt_shoe"]}-${langdata["txt_periode"]}`,
			langdata["txt_win"],

			"Dragon",
			"Tiger", //4

			`Dragon ${langdata["txt_odd"]}-${langdata["txt_even"]}`,
			`Tiger ${langdata["txt_odd"]}-${langdata["txt_even"]}`,

			`Dragon ${langdata["txt_big"]}-${langdata["txt_small"]}`,
			`Tiger ${langdata["txt_big"]}-${langdata["txt_small"]}`,

			`Dragon ${langdata["txt_black"]}-${langdata["txt_red"]}`,
			`Tiger ${langdata["txt_black"]}-${langdata["txt_red"]}`,
		];

		// TAB HEADER ELEMENTS
		const portraitHeaderIndices = (
			portraitTabIndex === 0 ? [0, 1, 2, 3, 4] :
				portraitTabIndex === 1 ? [0, 1, 5, 7, 9] :
					[0, 1, 6, 8, 10]
		);

		// TABLE BODY
		const bodyMapFunction = (item, idx) => {
			let cells: any[];

			if (isNullOrEmpty(item.dragon) ||
				isNullOrEmpty(item.tiger))
			{
				cells = [
					item.idnomor,
					`${item.gamekey}-${item.periode}`,
					..."-".repeat(9)
				];
			} else {
				const dragonValue = getDTCardValue(item.dragon),
					tigerValue = getDTCardValue(item.tiger),
					winColumn = (
						(item.dragon && item.tiger)
						?? (
							dragonValue > tigerValue
								? <div className="bg-red">D</div>
								: dragonValue === tigerValue
									? <div className="bg-green">Tie</div>
									: <div className="bg-yellow">T</div>
						)
					);

				cells = [
					item.idnomor,
					`${item.gamekey}-${item.periode}`,
					winColumn,

					assetImg("baccarat", item.dragon),
					assetImg("baccarat", item.tiger),

					dragonValue === 7 ? "-" : dragonValue % 2 ? langdata["txt_odd"] : langdata["txt_even"],
					tigerValue === 7 ? "-" : tigerValue % 2 ? langdata["txt_odd"] : langdata["txt_even"],

					dragonValue > 7 ? langdata["txt_big"] : dragonValue < 7 ? langdata["txt_small"] : "-",
					tigerValue > 7 ? langdata["txt_big"] : tigerValue < 7 ? langdata["txt_small"] : "-",

					dragonValue === 7 ? "-" : reds.includes(item.dragon[1]) ? langdata["txt_red"] : langdata["txt_black"],
					tigerValue === 7 ? "-" : reds.includes(item.tiger[1]) ? langdata["txt_red"] : langdata["txt_black"]
				];
			}



			//Template functions start here
			const landscapeColumns = cells.map((cell, _idx) =>
				<td key={"lC_" + _idx}>
					{cell}
				</td>
			), portraitColumns = portraitHeaderIndices.map((num, _idx) =>
				<td key={"pC_" + this.props.portraitTabIndex + _idx}>
					{cells[num]}
				</td>
			);

			return (
				<tr key={"tpdhm_" + idx}>
					{
						orientation === "landscape" ?
							landscapeColumns : portraitColumns
					}
				</tr>
			);
		};



		// Template Tab Headers, no need to change
		const headers = orientation === "landscape" ?
			landscapeHeaders :
			portraitHeaderIndices.map(num => landscapeHeaders[num]);

		// Template function, no need to change
		return renderResultHistory(
			this.props.activeGame.resultHistory,
			basePcode,
			headers,
			bodyMapFunction,

			this.props.gameResultHistoryPage,

			this.props.fetchResultHistory,
			this.props.changePortraitResultHistoryTab,
			// null,

			{
				mobile: this.props.mobile,
				mobileHome: this.props.mobileHome,
				desktop: this.props.desktop,
				orientation: orientation,
				tabNames: tabNames,

				portraitTabIndex: this.props.portraitTabIndex,
				showGameResultHistoryLoadingOverlay: this.props.showGameResultHistoryLoadingOverlay
			}
		);
	}
}
